export { default } from './Courses';


// WEBPACK FOOTER //
// ./src/partials/modules/Widgets/Courses/index.js